/**
 * design_handoff_auth §2 — the create-account split layout's right pane.
 *
 * PLACEHOLDER CONTENT: quote, name, role and customer wordmarks below are
 * shaped like the real thing per the handoff's own open question #1, but
 * are not real. Swap TESTIMONIALS and CUSTOMER_WORDMARKS for supplied
 * content before this ships.
 */
import React, { useCallback, useState } from "react";
import classNames from "classnames";
import { Icon } from "../../theme/untitled";
import styles from "./TestimonialPane.module.scss";

const TESTIMONIALS = [
  {
    quote:
      "Using Revisual transformed the prestige of our company. When marketing to a new client, it helps me gain their trust.",
    name: "Giorgos Grigorakos",
    role: "CEO and Production Director",
  }
];

const CUSTOMER_WORDMARKS = [
  "Northbank Hotels",
  "Marlowe Theatre",
  "Fieldhouse",
  "St Aldate's",
  "Riverside Arts",
];

// The theme's only star glyphs (StarIconFill*Color{Gray,Yellow}) bake a
// fixed rgb() fill into each path instead of using currentColor, so they
// can't take the brand-600 tint the handoff requires here — kept as an
// inline currentColor SVG instead of one of those icons.
const Stars = () => (
  <span className={styles.stars} title="Rated 5 out of 5">
    {Array.from({ length: 5 }).map((_, idx) => (
      <svg key={idx} viewBox="0 0 24 24" fill="currentColor" width={18} height={18}>
        <path d="M12 2l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 16.8 6.2 19.9l1.1-6.5L2.6 8.8l6.5-.9z" />
      </svg>
    ))}
  </span>
);

export const CompactTestimonial = () => {
  const testimonial = TESTIMONIALS[0];

  return (
    <div className={styles.compact}>
      <p className={styles.compactQuote}>"{testimonial.quote}"</p>
      <div className={styles.who}>
        <div>
          <div className={styles.name}>{testimonial.name}</div>
          <div className={styles.role}>{testimonial.role}</div>
        </div>
        <Stars />
      </div>
    </div>
  );
};

const TestimonialPane = () => {
  const [index, setIndex] = useState(0);
  const testimonial = TESTIMONIALS[index];

  const onPrev = useCallback(() => {
    setIndex((prev) => (prev - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  }, []);

  const onNext = useCallback(() => {
    setIndex((prev) => (prev + 1) % TESTIMONIALS.length);
  }, []);

  const dots = TESTIMONIALS.map((_, idx) => (
    <button
      key={idx}
      type="button"
      className={classNames(styles.dot, { [styles.dotOn]: idx === index })}
      aria-label={`Show testimonial ${idx + 1}`}
      onClick={() => setIndex(idx)}
    />
  ));

  const carousel = TESTIMONIALS.length > 1 ? (
    <div className={styles.carousel}>
      <span className={styles.dots}>{dots}</span>
      <span className={styles.arrows}>
        <button type="button" className={styles.arrowBtn} aria-label="Previous testimonial" onClick={onPrev}>
          <Icon name="ArrowLeft" size={18} />
        </button>
        <button type="button" className={styles.arrowBtn} aria-label="Next testimonial" onClick={onNext}>
          <Icon name="ArrowRight" size={18} />
        </button>
      </span>
    </div>
  ) : null;

  return (
    <div className={styles.pane}>
      <div className={styles.quoteBlock}>
        <blockquote className={styles.quote}>"{testimonial.quote}"</blockquote>
        <div className={styles.who}>
          <div>
            <div className={styles.name}>{testimonial.name}</div>
            <div className={styles.role}>{testimonial.role}</div>
          </div>
          <Stars />
        </div>
        {carousel}
      </div>
      {/* <div className={styles.proof}>
        <div className={styles.kicker}>Publishing events for teams at</div>
        <div className={styles.wordmarks}>
          {CUSTOMER_WORDMARKS.map((name) => (
            <span key={name}>{name}</span>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default TestimonialPane;
